export default "__VITE_ASSET__CK_6KqCq__"